module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_25-aa756b4c95a2e37ceb5e23be4e9becec.png";